


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master createUserWizard] Init';
export const DESTROY_SCREEN = '[Master createUserWizard] Destroy';


export const INIT_STATE = '[Master createUserWizard] Init State';
export const PREVIOUS = "[Master createUserWizard] Previous";
export const NEXT = "[Master createUserWizard] Next";
export const NEXT_SUCCESS = "[Master createUserWizard] Next Sucess";
export const NEXT_FAIL = "[Master createUserWizard] Next Fail";

export const CONFIRM = "[Master createUserWizard] Confirm";
export const CONFIRM_SUCCESS = "[Master createUserWizard] Confirm Sucess";
export const CONFIRM_FAIL = "[Master createUserWizard] Confirm Fail";

export const CHECK_STEP0_VALIDATION = '[Master createUser] Update Data';
export const CHECK_STEP1_VALIDATION = '[Master accessProfile] Update Data';

export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);
export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);
export const nextAction = ngrxCreateAction(NEXT, payload => payload);
export const nextSuccessAction = ngrxCreateAction(
  NEXT_SUCCESS,
  payload => payload
);
export const nextFailAction = ngrxCreateAction(NEXT_FAIL, payload => payload);
export const previousAction = ngrxCreateAction(PREVIOUS, payload => payload);
export const checkStep0ValidationAction = ngrxCreateAction(CHECK_STEP0_VALIDATION, payload => payload);
export const checkStep1ValidationAction = ngrxCreateAction(CHECK_STEP1_VALIDATION, payload => payload);
export const confirmAction = ngrxCreateAction(CONFIRM, payload => payload);
export const confirmSuccessAction = ngrxCreateAction(
  CONFIRM_SUCCESS,
  payload => payload
);
export const confirmFailAction = ngrxCreateAction(CONFIRM_FAIL, payload => payload);


